// AIDEV-NOTE: `name` testu je párovací klíč na rezervace ze Zóny (`m_test_d21`), ne text pro
// studenty. Titulek bere `displayName` z CMS a teprve bez něj `name`; prázdný řetězec
// z CMS se počítá jako nevyplněný. [TD-410]
export const getAdmissionTestLabel = (
  admissionTest?: { name?: string | null; displayName?: string | null } | null,
): string | undefined => admissionTest?.displayName?.trim() || admissionTest?.name || undefined;

export const parseAssignmentDetailTitle = (subjectAbbr?: string, testId?: string, testOrder?: number) => {
  let title = "";

  if (subjectAbbr) title += subjectAbbr;

  if (testId) {
    if (title) title += ", ";
    title += `test ${testId}`;
  }

  if (testOrder) {
    if (title) title += ", ";
    title += `úloha ${testOrder}`;
  }

  return title;
};

// AIDEV-NOTE: Detail úlohy bez tématu (/ulohy/detail/:id) se tlačítkem Zpět vrací na /ulohy.
// Stránka, která na něj proklikne a chce návrat k sobě, pošle `state: { from }` — whitelist
// hlídá, aby `from` nemohl vést mimo aplikaci ani na stránku, kam návrat z úlohy nepatří. [TD-334]
export const ASSIGNMENT_RETURN_PATHS = ["/reklamovane-odpovedi"] as const;

export const resolveAssignmentReturnPath = (state: unknown): string | undefined => {
  const from = typeof state === "object" && state !== null && "from" in state ? state.from : undefined;

  return ASSIGNMENT_RETURN_PATHS.find(path => path === from);
};
